import React from 'react';
import PropTypes from 'prop-types';
import { asList } from './utils';

const SessionChips = ({ item }) => {
  const levels = asList(item.session_level);
  const audiences = asList(item.session_audience);
  const languages = asList(item.session_language);
  const durations = asList(item.duration);
  const hasChips =
    levels.length > 0 ||
    audiences.length > 0 ||
    languages.length > 0 ||
    durations.length > 0;

  if (!hasChips) return null;

  return (
    <div className="session-item__chips">
      {levels.map((lvl, i) => (
        <span
          key={`lvl-${i}`}
          className="session-item__chip session-item__chip--level"
        >
          {lvl.title}
        </span>
      ))}

      {audiences.map((aud, i) => (
        <span key={`aud-${i}`} className="session-item__chip">
          {aud.title}
        </span>
      ))}

      {languages.map((lang, i) => (
        <span key={`lang-${i}`} className="session-item__chip">
          {lang.title}
        </span>
      ))}

      {durations.map((dur, i) => (
        <span key={`dur-${i}`} className="session-item__chip">
          {dur.title}
        </span>
      ))}
    </div>
  );
};

SessionChips.propTypes = {
  item: PropTypes.shape({
    session_level: PropTypes.any,
    session_audience: PropTypes.any,
    session_language: PropTypes.any,
    duration: PropTypes.any,
  }).isRequired,
};

export default SessionChips;
